import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { GatsbyImage } from 'gatsby-plugin-image';

import { Container, colors, Heading, media, AnimateIn, TitleSet } from '../ui-components';
import renderRichText from '../utils/render-rich-text';

const renderPointOfViewSquares = (items, geoSpace) => {
  if (items) {
    const PromptSquares = items?.map(item => {
      return (
        <PromptSquare>
          <Heading level="5">{item.title}</Heading>
          {renderRichText(item.content, geoSpace, 'medium')}
        </PromptSquare>
      );
    });

    const ImageSquares = items?.map(item => {
      return item?.image?.data && <ImageSquare image={item.image.data} alt={'Our Initiatives Image'} />;
    });

    let alternatingSquares = [];
    let tabletSquares = [];
    for (let i = 0; i < 3; i++) {
      alternatingSquares.push(PromptSquares[i]);
      alternatingSquares.push(ImageSquares[i]);

      if (i == 1) {
        tabletSquares.push(ImageSquares[i]);
        tabletSquares.push(PromptSquares[i]);
      } else {
        tabletSquares.push(PromptSquares[i]);
        tabletSquares.push(ImageSquares[i]);
      }
    }
    const [displaySquares, setDisplaySquares] = useState(alternatingSquares);

    useEffect(() => {
      function handleResize() {
        const mq1 = window.matchMedia(`(max-width: ${media.largeTop})`);
        const mq2 = window.matchMedia(`(max-width: ${media.mediumBottom})`);

        if (mq1.matches && !mq2.matches) {
          setDisplaySquares(tabletSquares);
        } else {
          setDisplaySquares(alternatingSquares);
        }
      }
      window.addEventListener('resize', handleResize);

      return () => window.removeEventListener('resize', handleResize);
    });

    return (
      <AnimateIn onScroll>
        <Squares>{displaySquares}</Squares>
      </AnimateIn>
    );
  }
};

const PromptSquare = styled.div`
  background: ${colors.pureWhite};
  box-shadow: 0px 0px 80px 0px rgba(58, 58, 58, 0.06);
  display: flex;
  max-width: 420px;
  min-height: 400px;
  padding: 40px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
`;

const Squares = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;

  @media screen and (max-width: ${media.largeTop}) {
  
    grid-template-columns: repeat(2, 1fr);

    div {
      max-width: 100%;
    }
  }
  
  @media screen and (max-width: ${media.mediumBottom}) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

const ImageSquare = styled(GatsbyImage)`
  max-width: 420px;
  min-height: 400px;
`;

export default renderPointOfViewSquares;
